import React, { useEffect, useState, useContext } from "react";
import {
  getCustomers,
  deleteCustomers,
  createCustomers,
  updateCustomers,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditCustomers } from "./Form";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { CommonCardUi, InputField, SelectField, TextArea } from "../../Common/CommonCard";
import { WarehouseContext } from "../../../Utility/UserContext";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { useLocation } from "react-router-dom";

const Customers_list = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [customers, setCustomers] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);
  const [addoredit, setaddoredit] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [editButton, setEditButton] = useState(false);
  const [cardForm, setCardForm] = useState(0);
  const rolesPerPage = 10; // Number of roles per page

  const [searchText, setSearchText] = useState("");
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

  const [formdata, setFormdata] = useState({
    name: "",
    contact_email: "",
    phone: "",
    country: "",
    branch: "",
    status: "0",
    additional_details: "",
    customer_type: "",
    TRN_no: "",
    opening_balance: "",
    CR_DR: "0",
    shop_id: `${shopItem?.shop_id || "0"}`,
  });

  const [errors, setErrors] = useState({
    contact_email: "",
    phone: "",
  });

  useEffect(() => {
    fetchCustomers(currentPage);
  }, []);

  const handledeletemodel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  };

  const fetchCustomers = async (page = 1, text = searchText) => {
    showLoader();
    try {
      const response = await getCustomers(page, text);
      if (response.data && response.data.data) {
        setCustomers(response.data.data);
        setTotalPages(response.data.pagination.total_pages); // Update total pages for pagination
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching Customers data:", error);
      hideLoader();
    }
  };

  const openAddModal = () => {
    setaddoredit(true);
    setShowEditModal(!showEditModal);
  };

  const openEditModal = (cus) => {
    setEditButton(true);
    setSelectedCustomers(cus);
    setCardForm(1);
    setFormdata({
      ...formdata,
      name: cus?.name,
      contact_email: cus.contact_email,
      phone: cus.phone,
      country: cus.country,
      branch: cus.branch,
      additional_details: cus.additional_details,
      TRN_no: cus.TRN_no,
      opening_balance: cus.opening_balance,
      CR_DR: cus.CR_DR,
    });
  };

  const handleDelete = async () => {
    showLoader();
    try {
      await deleteCustomers(deleteID);
      showDeletemodel(false);
      hideLoader();
      toast.error("Customers is Inactivated");
      await fetchCustomers(currentPage);
    } catch (error) {
      console.error("Error deleting Customers:", error);
      hideLoader();
      toast.error("Error deleting Customers");
    }
  };

  const HandleUndoDelete = async (id) => {
    showLoader();
    try {
      await deleteCustomers(id);
      await fetchCustomers(currentPage);
      toast.success("Customer is Activated");
      hideLoader();
    } catch (err) {
      console.error(err);
      toast.error("Error deleting Customers");
    }
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchCustomers(pageNumber);
  };

  const handleSearch = async (text) => {
    fetchCustomers(1, text);
    setCurrentPage(1);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" || name == "opening_balance") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormdata({
        ...formdata,
        [name]: numericValue,
      });
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
      return;
    }
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormdata({
      ...formdata,
      [name]: value,
    });
  };

  const handleSubmit = async (e, AddorEdit) => {
    showLoader();
    const validationErrors = {};

    if (!formdata.phone || formdata.phone.length < 10 ) {
      validationErrors.phone = !formdata.phone
        ? "Phone number is required."
        : "Phone number must be at least 10 digits";
    }

    for (const key in formdata) {
      if (
        key === "additional_details" ||
        key === "status" ||
        key === "country" ||
        key === "TRN_no" ||
        key === "branch" ||
        key === "opening_balance" ||
        key === "CR_DR"
      ) {
        continue;
      }
      // if (!formdata[key]) {
      if (!formdata[key] && key !== "contact_email" && key !== "phone") {
        validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
      }
    }
    if (!validateEmail(formdata.contact_email)) {
      validationErrors.contact_email = "Invalid email address";
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      console.log(validationErrors);
      return;
    }

    console.log("Payload being sent:", formdata);

    try {
      if (AddorEdit == 0) {
        await createCustomers(formdata);
        hideLoader();
        toast.success("Customers Added successfully");
        setCardForm(0);
        setCurrentPage(1);
      } else {
        await updateCustomers(selectedCustomers?.customer_id, formdata);
        hideLoader();
        toast.success("Customers Updated successfully");
        setCardForm(0);
        setCurrentPage(1);
      }
      setErrors({});
      fetchCustomers();
      handleclear();
    } catch (error) {
      console.error("Error  data:", error.response?.data.message);
      hideLoader();
      toast.error(error.response?.data.message);
    }
  };

  const handleclear = () => {
    setFormdata({
      name: "",
      contact_email: "",
      phone: "",
      country: "",
      branch: "",
      status: "",
      additional_details: "",
      TRN_no: "",
      opening_balance: "",
      customer_type: "",
      CR_DR: "0",
      shop_id: `${shopItem?.shop_id || "0"}`,
    });
    setEditButton(false);
    setErrors({});
  };

  const feilds = (
    <>
      <div className="col-lg-6 col-12">
        {InputField(
          "Customers",
          "name",
          "text",
          formdata.name,
          handleChange,
          "Enter Name",
          12,
          null,
          errors.name
        )}
        {InputField(
          "Email",
          "contact_email",
          "text",
          formdata.contact_email,
          handleChange,
          "Enter Email",
          12,
          null,
          errors.contact_email
        )}
        {InputField(
          "Phone",
          "phone",
          "text",
          formdata.phone,
          handleChange,
          "Enter Phone",
          12,
          null,
          errors.phone
        )}
        {InputField(
          "Country",
          "country",
          "text",
          formdata.country,
          handleChange,
          "Enter Country",
          12,
          null,
          errors.country
        )}
        {InputField(
          "TRN.no",
          "TRN_no",
          "text",
          formdata.TRN_no,
          handleChange,
          "Enter TRN",
          12,
          null,
          errors.TRN_no
        )}
        {InputField(
          "Branch",
          "branch",
          "text",
          formdata.branch,
          handleChange,
          "Enter Branch",
          12,
          null,
          errors.branch
        )}
      </div>
      <div className="col-lg-6 col-12">
        {/* {InputField('Additional Details','additional_details','text',formdata.additional_details,handleChange,'Enter Additional Details',12,null,errors.additional_details)} */}
        {TextArea(
          "Additional Details",
          "additional_details",
          "text",
          formdata.additional_details,
          handleChange,
          "give some additional details",
          12,
          true
        )}

        {/* {SelectField(
          "Customer Type",
          "customer_type",
          formdata.customer_type,
          handleChange,
          [
            { value: "agent", label: "Agent" },
            { value: "customer", label: "Customer" }
          ]
        )} */}

        {SelectField(
          "Customer Type",
          "customer_type",
          formdata.customer_type,
          handleChange,
          [
            { value: "agent", label: "Agent" },
            { value: "customer", label: "Customer" },
          ],
          12,
          null,
          errors.customer_type,
        )}

        {/* <div className="d-flex column-gap-1">
          {InputField(
            "Balance",
            "opening_balance",
            "text",
            formdata.opening_balance,
            handleChange,
            "Enter Balance",
            8,
            null,
            errors.opening_balance
          )}
          <div className="col-4">
            <select
              name="CR_DR"
              value={formdata.CR_DR}
              onChange={handleChange}
              className=""
              style={{
                height: "1.5rem",
                margin: "1px",
                fontSize: "0.7rem",
              }}
            >
              <option value="">Select CR DR</option>
              <option key="0" value="0">
                CR
              </option>
              <option key="1" value="1">
                DR
              </option>
            </select>
          </div>
        </div> */}
      </div>
    </>
  );

  return (
    <div className="page-wrappers">
      <div className="page-content">
        {/*end breadcrumb*/}
        <NaviGate />

        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>
            Customers list
          </h6>
          {!readonly && <button
            type="button"
            onClick={() => {
              setCardForm(1);
              setErrors({});
            }}
            className="btn btn-primary mb-0 text-normal"
            style={{ fontFamily: "poppins", borderRadius: "6px" }}
          >
            Add Customers
          </button>}
        </div>
        <hr className="mt-1" />

        {cardForm == 1 && (
          <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ fontFamily: "poppins" }}>
              <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
                <div className="modal-content shadow border-0" style={{ borderRadius: "12px" }}>
                  <div className="modal-header px-4 pt-3 pb-2 border-0">
                    <h5 className="modal-title fw-bold" style={{ fontSize: "20px", color: "#1e293b" }}>
                      {editButton ? "Edit Customer" : "Add Customer"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setCardForm(0);
                        handleclear();
                      }}
                    ></button>
                  </div>
                  <form onSubmit={(e) => { e.preventDefault(); handleSubmit(e, editButton ? 1 : 0); }}>
                    <div className="modal-body px-4 py-2">
                      <div className="row g-2">
                        {/* Left Column */}
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Customers <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="name"
                              value={formdata.name}
                              onChange={handleChange}
                              placeholder="Enter Name"
                              className={`form-control py-2 ${errors.name ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Email <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="contact_email"
                              value={formdata.contact_email}
                              onChange={handleChange}
                              placeholder="Enter Email"
                              className={`form-control py-2 ${errors.contact_email ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.contact_email && <div className="invalid-feedback">{errors.contact_email}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Phone <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="phone"
                              value={formdata.phone}
                              onChange={handleChange}
                              placeholder="Enter Phone"
                              className={`form-control py-2 ${errors.phone ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Country
                            </label>
                            <input
                              type="text"
                              name="country"
                              value={formdata.country}
                              onChange={handleChange}
                              placeholder="Enter Country"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              TRN.no
                            </label>
                            <input
                              type="text"
                              name="TRN_no"
                              value={formdata.TRN_no}
                              onChange={handleChange}
                              placeholder="Enter TRN"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Branch
                            </label>
                            <input
                              type="text"
                              name="branch"
                              value={formdata.branch}
                              onChange={handleChange}
                              placeholder="Enter Branch"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Additional Details
                            </label>
                            <textarea
                              name="additional_details"
                              value={formdata.additional_details}
                              onChange={handleChange}
                              placeholder="give some additional details"
                              className="form-control py-2"
                              rows={5}
                              style={{ borderRadius: "6px", fontSize: "14px", resize: "none" }}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Customer Type <span className="text-danger">*</span>
                            </label>
                            <select
                              name="customer_type"
                              value={formdata.customer_type}
                              onChange={handleChange}
                              className={`form-select py-2 ${errors.customer_type ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            >
                              <option value="">Customer Type</option>
                              <option value="agent">Agent</option>
                              <option value="customer">Customer</option>
                            </select>
                            {errors.customer_type && <div className="invalid-feedback">{errors.customer_type}</div>}
                          </div>
                        </div>
                      </div>
                      <div className="text-end mt-4">
                        <button
                          type="button"
                          className="btn btn-secondary px-4 py-2 me-2"
                          style={{ borderRadius: "6px", fontSize: "14px" }}
                          onClick={() => {
                            setCardForm(0);
                            handleclear();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary px-4 py-2"
                          style={{ borderRadius: "6px", fontSize: "14px" }}
                        >
                          {editButton ? "Update" : "Save"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        )}

        {cardForm == 0 && (
          <div className="card">
            <div className="card-body">
              <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                <div
                  className="d-flex position-relative"
                  style={{ width: "100%" }}
                >
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search..."
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      handleSearch(e.target.value)
                    }}
                  />
                  <img
                    src="/assets/images/icons/search.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "18px",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </div>
              <div
                className="table-responsive"
                style={{ fontFamily: "poppins" }}
              >
                <table
                  id="example"
                  className="table  table-sm table-striped table-bordered"
                  style={{ width: "100%", style: "poppins" }}
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Country</th>
                      <th>Branch</th>
                      {/* <th>status</th> */}
                      <th>Additional Details</th>
                      {!readonly && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {customers.map((cus, index) => (
                      <tr key={cus.customer_id}>
                        <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                        <td>{cus.name}</td>
                        <td>{cus.contact_email}</td>
                        <td>{cus.phone}</td>
                        <td>{cus.country}</td>
                        <td>{cus.branch}</td>
                        <td>{cus.additional_details}</td>
                        {!readonly && <td>
                          {cus.status == null || cus.status == 0 ? (
                            <>
                              <img
                                src="/assets/images/icons/edit.png"
                                onClick={() => openEditModal(cus)}
                                height={"16px"}
                              />
                              &nbsp;&nbsp;&nbsp;
                              <img
                                src="/assets/images/icons/delete.png"
                                className="mx"
                                onClick={() =>
                                  handledeletemodel(cus.customer_id)
                                }
                                height={"16px"}
                              />
                            </>
                          ) : (
                            <button
                              className="btn btn-secondary px-2 py-1 rounded-1"
                              style={{ fontSize: "13px" }}
                              onClick={() => HandleUndoDelete(cus.customer_id)}
                            >
                              Inactive
                            </button>
                          )}
                        </td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      <EditCustomers
        showModal={showEditModal}
        setShowModal={() => openEditModal()}
        fetchCustomers={() => fetchCustomers()}
        selectedCustomers={selectedCustomers}
        AddorEdit={addoredit}
      />
    </div>
  );
};

export default Customers_list;
